import { createSelector } from '@reduxjs/toolkit'
import { selectInstances } from './selectInstances'

export const selectInstanceNames = createSelector(
	[selectInstances],
	(instances) => {
		const instanceNames = instances?.reduce((acc: string[], instance) => {
			if (instance.instanceName) {
				acc.push(instance.instanceName)
			}
			return acc
		}, [])
		return Array.from(new Set(instanceNames))
	})